import React from 'react'
import { usePostHog } from 'posthog-js/react'

const marqueeItems = [
  'iOS & Android',
  '·',
  'React & Next.js',
  '·',
  'Node.js & APIs',
  '·',
  'Cloud infrastructure',
  '·',
  'Enterprise SaaS',
  '·',
  'Product strategy',
  '·',
  'UI/UX design',
  '·'
]

const Hero: React.FC = () => {
  const posthog = usePostHog()

  return (
    <section className='w-full overflow-hidden pt-20 md:pt-28 pb-0 text-center' id='top'>
      <div className='max-w-[960px] mx-auto px-4 md:px-10'>
        <h1 className='font-hd text-[28px] sm:text-[44px] md:text-[64px] font-extrabold leading-[1.1] md:leading-[1.04] tracking-[-1px] sm:tracking-[-2px] md:tracking-[-3px] mb-6 animate-fade-up'>
          Software that <em className='not-italic gradient-text'>actually ships.</em>
        </h1>
        <p className='text-[16px] md:text-[19px] text-ink2 leading-[1.7] max-w-[540px] mx-auto mb-10 animate-fade-up-delay-1'>
          Most agencies overpromise and underdeliver. We&rsquo;re a small, senior team that builds
          mobile apps, web platforms, and cloud systems — and we ship them on time.
        </p>
        <div className='flex justify-center gap-3 flex-wrap animate-fade-up-delay-2 pb-16'>
          <a
            href='#contact'
            onClick={() => posthog?.capture('hero_cta_clicked')}
            className='inline-flex items-center gap-2 px-6 py-3 md:px-[30px] md:py-[15px] rounded-[10px] bg-pop text-white font-semibold text-[14px] md:text-[15px] hover:bg-pop-hover hover:-translate-y-px transition-all no-underline'
          >
            Talk to us today →
          </a>
          <a
            href='#services'
            onClick={() => posthog?.capture('hero_services_clicked')}
            className='inline-flex items-center gap-2 px-6 py-3 md:px-[30px] md:py-[15px] rounded-[10px] bg-transparent text-ink border border-black/10 font-semibold text-[14px] md:text-[15px] hover:border-pop hover:text-pop hover:bg-[rgba(37,83,232,0.06)] transition-all no-underline'
          >
            What we do
          </a>
        </div>
      </div>

      <div className='border-t border-b border-black/[0.06] py-[1.4rem] overflow-hidden whitespace-nowrap'>
        <div className='marquee-track'>
          {[...marqueeItems, ...marqueeItems].map((item, i) => (
            <span
              key={i}
              className='font-hd text-[13px] font-bold tracking-[1.5px] uppercase text-ink4'
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Hero
